import { valueof } from './Common';
import { ATTRIBUTE_DISPLAY_STYLE, ATTRIBUTE_STYLE, ColorCd } from './constant';

/** プロジェクト詳細取得Basicモード */
export interface LoadProjectBasic {
  readonly projectId: number;
  readonly projectName: string;
  readonly organizationId: number;
  readonly projectIconImage: string | null;
  readonly projectHeaderImage: string | null;
  readonly projectBackgroundImage: string | null;
  readonly projectOutline: string | null;
  readonly projectWillFinishDate: Date | null;
  readonly projectStartDate: Date | null;
  readonly openFlag: boolean;
}

export interface FetchProjectBasic {
  results: LoadProjectBasic;
}

/** プロジェクト型 */
export interface Project {
  readonly projectId: number,
  readonly projectName: string,
  readonly organizationId: number,
  readonly projectIconImage: string | null,
  readonly projectHeaderImage: string | null,
  readonly projectBackgroundImage: string | null,
  readonly projectOutline: string | null,
  readonly projectStartDate: number | null,
  readonly projectWillFinishDate: Date | null,
  readonly projectFinishDate: Date | null,
  readonly categoryAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  readonly categoryAttributeDisplayFlag: boolean,
  readonly priorityAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  readonly priorityAttributeDisplayFlag: boolean,
  readonly statusAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  readonly statusAttributeDisplayFlag: boolean,
  readonly customAttribute1Name: string | null,
  readonly customAttribute1Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute1DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute1DisplayFlag: boolean,
  readonly customAttribute2Name: string | null,
  readonly customAttribute2Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute2DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute2DisplayFlag: boolean,
  readonly customAttribute3Name: string | null,
  readonly customAttribute3Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute3DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute3DisplayFlag: boolean,
  readonly customAttribute4Name: string | null,
  readonly customAttribute4Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute4DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute4DisplayFlag: boolean,
  readonly customAttribute5Name: string | null,
  readonly customAttribute5Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute5DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute5DisplayFlag: boolean,
  readonly customAttribute6Name: string | null,
  readonly customAttribute6Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute6DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute6DisplayFlag: boolean,
  readonly customAttribute7Name: string | null,
  readonly customAttribute7Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute7DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute7DisplayFlag: boolean,
  readonly customAttribute8Name: string | null,
  readonly customAttribute8Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute8DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute8DisplayFlag: boolean,
  readonly customAttribute9Name: string | null,
  readonly customAttribute9Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute9DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute9DisplayFlag: boolean,
  readonly customAttribute10Name: string | null,
  readonly customAttribute10Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute10DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute10DisplayFlag: boolean,
  readonly customAttribute11Name: string | null,
  readonly customAttribute11Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute11DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute11DisplayFlag: boolean,
  readonly customAttribute12Name: string | null,
  readonly customAttribute12Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute12DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute12DisplayFlag: boolean,
  readonly customAttribute13Name: string | null,
  readonly customAttribute13Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute13DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute13DisplayFlag: boolean,
  readonly customAttribute14Name: string | null,
  readonly customAttribute14Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute14DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute14DisplayFlag: boolean,
  readonly customAttribute15Name: string | null,
  readonly customAttribute15Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute15DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute15DisplayFlag: boolean,
  readonly customAttribute16Name: string | null,
  readonly customAttribute16Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute16DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute16DisplayFlag: boolean,
  readonly customAttribute17Name: string | null,
  readonly customAttribute17Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute17DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute17DisplayFlag: boolean,
  readonly customAttribute18Name: string | null,
  readonly customAttribute18Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute18DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute18DisplayFlag: boolean,
  readonly customAttribute19Name: string | null,
  readonly customAttribute19Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute19DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute19DisplayFlag: boolean,
  readonly customAttribute20Name: string | null,
  readonly customAttribute20Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute20DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute20DisplayFlag: boolean,
  readonly customAttribute21Name: string | null,
  readonly customAttribute21Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute21DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute21DisplayFlag: boolean,
  readonly customAttribute22Name: string | null,
  readonly customAttribute22Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute22DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute22DisplayFlag: boolean,
  readonly customAttribute23Name: string | null,
  readonly customAttribute23Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute23DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute23DisplayFlag: boolean,
  readonly customAttribute24Name: string | null,
  readonly customAttribute24Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute24DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute24DisplayFlag: boolean,
  readonly customAttribute25Name: string | null,
  readonly customAttribute25Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute25DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute25DisplayFlag: boolean,
  readonly customAttribute26Name: string | null,
  readonly customAttribute26Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute26DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute26DisplayFlag: boolean,
  readonly customAttribute27Name: string | null,
  readonly customAttribute27Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute27DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute27DisplayFlag: boolean,
  readonly customAttribute28Name: string | null,
  readonly customAttribute28Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute28DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute28DisplayFlag: boolean,
  readonly customAttribute29Name: string | null,
  readonly customAttribute29Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute29DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute29DisplayFlag: boolean,
  readonly customAttribute30Name: string | null,
  readonly customAttribute30Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null,
  readonly customAttribute30DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null,
  readonly customAttribute30DisplayFlag: boolean,
  readonly openFlag: boolean,
}

/** プロジェクト登録 */
export type CreateProjectDto = Omit<
  Project,
  | 'projectId'
  | 'projectFinishDate'
  | 'categoryAttributeDisplayStyle'
  | 'categoryAttributeDisplayFlag'
  | 'priorityAttributeDisplayStyle'
  | 'priorityAttributeDisplayFlag'
  | 'statusAttributeDisplayStyle'
  | 'statusAttributeDisplayFlag'
>;

/** プロジェクト登録APIレスポンス */
export interface CreateProjectResponse {
  readonly results: {
    readonly projectId: number;
  };
}

/** プロジェクト詳細取得レスポンス */
export interface FindOneProjectResponse {
  readonly results: Project;
}

/** プロジェクト詳細取得モード */
export const ProjectGetMode = {
  all: 'all',
  basic: 'basic',
} as const;

/** プロジェクト詳細取得 */
export interface FindOneProjectQuery {
  'get-mode': valueof<keyof typeof ProjectGetMode>;
}

/** 課題属性値選択項目更新リクエストパラメータ */
export interface UpdateProjectTaskAttributeValueOptionsParam {
  projectCustomAttribute?: UpdateProjectCustomAttributesParam;
  taskAttributes?: UpdateTaskAttributeParam[];
};

/** プロジェクト（カスタム属性）更新リクエストパラメータ */
export interface UpdateProjectCustomAttributesParam {
  categoryAttributeDisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  categoryAttributeDisplayFlag?: boolean,
  priorityAttributeDisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  priorityAttributeDisplayFlag?: boolean,
  statusAttributeDisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  statusAttributeDisplayFlag?: boolean,
  customAttribute1Name?: string | null;
  customAttribute1Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute1DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute1DisplayFlag?: boolean;
  customAttribute2Name?: string | null;
  customAttribute2Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute2DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute2DisplayFlag?: boolean;
  customAttribute3Name?: string | null;
  customAttribute3Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute3DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute3DisplayFlag?: boolean;
  customAttribute4Name?: string | null;
  customAttribute4Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute4DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute4DisplayFlag?: boolean;
  customAttribute5Name?: string | null;
  customAttribute5Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute5DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute5DisplayFlag?: boolean;
  customAttribute6Name?: string | null;
  customAttribute6Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute6DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute6DisplayFlag?: boolean;
  customAttribute7Name?: string | null;
  customAttribute7Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute7DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute7DisplayFlag?: boolean;
  customAttribute8Name?: string | null;
  customAttribute8Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute8DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute8DisplayFlag?: boolean;
  customAttribute9Name?: string | null;
  customAttribute9Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute9DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute9DisplayFlag?: boolean;
  customAttribute10Name?: string | null;
  customAttribute10Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute10DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute10DisplayFlag?: boolean;
  customAttribute11Name?: string | null;
  customAttribute11Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute11DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute11DisplayFlag?: boolean;
  customAttribute12Name?: string | null;
  customAttribute12Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute12DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute12DisplayFlag?: boolean;
  customAttribute13Name?: string | null;
  customAttribute13Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute13DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute13DisplayFlag?: boolean;
  customAttribute14Name?: string | null;
  customAttribute14Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute14DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute14DisplayFlag?: boolean;
  customAttribute15Name?: string | null;
  customAttribute15Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute15DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute15DisplayFlag?: boolean;
  customAttribute16Name?: string | null;
  customAttribute16Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute16DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute16DisplayFlag?: boolean;
  customAttribute17Name?: string | null;
  customAttribute17Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute17DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute17DisplayFlag?: boolean;
  customAttribute18Name?: string | null;
  customAttribute18Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute18DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute18DisplayFlag?: boolean;
  customAttribute19Name?: string | null;
  customAttribute19Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute19DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute19DisplayFlag?: boolean;
  customAttribute20Name?: string | null;
  customAttribute20Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute20DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute20DisplayFlag?: boolean;
  customAttribute21Name?: string | null;
  customAttribute21Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute21DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute21DisplayFlag?: boolean;
  customAttribute22Name?: string | null;
  customAttribute22Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute22DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute22DisplayFlag?: boolean;
  customAttribute23Name?: string | null;
  customAttribute23Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute23DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute23DisplayFlag?: boolean;
  customAttribute24Name?: string | null;
  customAttribute24Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute24DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute24DisplayFlag?: boolean;
  customAttribute25Name?: string | null;
  customAttribute25Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute25DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute25DisplayFlag?: boolean;
  customAttribute26Name?: string | null;
  customAttribute26Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute26DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute26DisplayFlag?: boolean;
  customAttribute27Name?: string | null;
  customAttribute27Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute27DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute27DisplayFlag?: boolean;
  customAttribute28Name?: string | null;
  customAttribute28Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute28DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute28DisplayFlag?: boolean;
  customAttribute29Name?: string | null;
  customAttribute29Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute29DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute29DisplayFlag?: boolean;
  customAttribute30Name?: string | null;
  customAttribute30Style?: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute30DisplayStyle?: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute30DisplayFlag?: boolean;
}

export interface UpdateTaskAttributeParam {
  readonly attributeCd: valueof<keyof typeof AttributeCd>;
  readonly value: string;
  readonly colorCd: valueof<keyof typeof ColorCd>;
  readonly attributeItemContent: string | null;
}

/** 課題属性値選択項目更新クエリパラメータ */
export interface UpdateTaskAttributeValueOptionsQuery {
  'update-mode': valueof<keyof typeof TaskAttributeValueOptionsUpdateMode>;
  'attribute-code': valueof<keyof typeof AttributeCd>[];
}

/** 課題属性値選択項目更新モード */
export const TaskAttributeValueOptionsUpdateMode = {
  all: 'all',
  taskOnly: 'task-only',
} as const;

/** 属性CD */
export const AttributeCd = {
  category: 'category',
  priority: 'priority',
  status: 'status',
  attribute1: 'attribute1',
  attribute2: 'attribute2',
  attribute3: 'attribute3',
  attribute4: 'attribute4',
  attribute5: 'attribute5',
  attribute6: 'attribute6',
  attribute7: 'attribute7',
  attribute8: 'attribute8',
  attribute9: 'attribute9',
  attribute10: 'attribute10',
  attribute11: 'attribute11',
  attribute12: 'attribute12',
  attribute13: 'attribute13',
  attribute14: 'attribute14',
  attribute15: 'attribute15',
  attribute16: 'attribute16',
  attribute17: 'attribute17',
  attribute18: 'attribute18',
  attribute19: 'attribute19',
  attribute20: 'attribute20',
  attribute21: 'attribute21',
  attribute22: 'attribute22',
  attribute23: 'attribute23',
  attribute24: 'attribute24',
  attribute25: 'attribute25',
  attribute26: 'attribute26',
  attribute27: 'attribute27',
  attribute28: 'attribute28',
  attribute29: 'attribute29',
  attribute30: 'attribute30',
} as const;

/** 課題属性値選択項目一覧取得レスポンス型 */
export interface FindProjectTaskAttributeValueOptionsResponse {
  results: TaskAttributeValueOption[];
}

export interface TaskAttributeValueOption {
  taskAttributeValueOptionId: number;
  projectId: number;
  attributeCd: valueof<keyof typeof AttributeCd>;
  value: string | null;
  colorCd: valueof<keyof typeof ColorCd>;
  attributeItemContent: string | null;
  identifer?: number;
}

export interface UpdateProjectDto {
  readonly projectName: string;
  readonly projectIconImage: string | null;
  readonly projectHeaderImage?: string | null;
  readonly projectBackgroundImage?: string | null;
  readonly projectOutline: string | null;
  readonly projectStartDate: string | null;
  readonly projectWillFinishDate: string | null;
  readonly openFlag: boolean;
}

export interface UpdateProjectParams {
  projectId: number;
  data: UpdateProjectDto;
}

export interface ProjectCustomAttributeType {
  attributeCd: valueof<keyof typeof AttributeCd>;
  attributeName: string | null;
  attributeStyle: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  attributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  attributeDisplayFlag: boolean;
  attributeOptions: TaskAttributeValueOption[];
}

export interface UpdateCustomAttributesDto {
  projectId: number;
  data: AllUpdateProjectCustomAttributesParam;
}

/** プロジェクト（カスタム属性・all）更新リクエストパラメータ */
export interface AllUpdateProjectCustomAttributesParam {
  categoryAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  categoryAttributeDisplayFlag: boolean,
  priorityAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  priorityAttributeDisplayFlag: boolean,
  statusAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>,
  statusAttributeDisplayFlag: boolean,
  customAttribute1Name: string | null;
  customAttribute1Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute1DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute1DisplayFlag: boolean;
  customAttribute2Name: string | null;
  customAttribute2Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute2DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute2DisplayFlag: boolean;
  customAttribute3Name: string | null;
  customAttribute3Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute3DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute3DisplayFlag: boolean;
  customAttribute4Name: string | null;
  customAttribute4Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute4DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute4DisplayFlag: boolean;
  customAttribute5Name: string | null;
  customAttribute5Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute5DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute5DisplayFlag: boolean;
  customAttribute6Name: string | null;
  customAttribute6Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute6DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute6DisplayFlag: boolean;
  customAttribute7Name: string | null;
  customAttribute7Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute7DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute7DisplayFlag: boolean;
  customAttribute8Name: string | null;
  customAttribute8Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute8DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute8DisplayFlag: boolean;
  customAttribute9Name: string | null;
  customAttribute9Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute9DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute9DisplayFlag: boolean;
  customAttribute10Name: string | null;
  customAttribute10Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute10DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute10DisplayFlag: boolean;
  customAttribute11Name: string | null;
  customAttribute11Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute11DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute11DisplayFlag: boolean;
  customAttribute12Name: string | null;
  customAttribute12Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute12DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute12DisplayFlag: boolean;
  customAttribute13Name: string | null;
  customAttribute13Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute13DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute13DisplayFlag: boolean;
  customAttribute14Name: string | null;
  customAttribute14Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute14DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute14DisplayFlag: boolean;
  customAttribute15Name: string | null;
  customAttribute15Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute15DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute15DisplayFlag: boolean;
  customAttribute16Name: string | null;
  customAttribute16Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute16DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute16DisplayFlag: boolean;
  customAttribute17Name: string | null;
  customAttribute17Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute17DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute17DisplayFlag: boolean;
  customAttribute18Name: string | null;
  customAttribute18Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute18DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute18DisplayFlag: boolean;
  customAttribute19Name: string | null;
  customAttribute19Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute19DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute19DisplayFlag: boolean;
  customAttribute20Name: string | null;
  customAttribute20Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute20DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute20DisplayFlag: boolean;
  customAttribute21Name: string | null;
  customAttribute21Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute21DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute21DisplayFlag: boolean;
  customAttribute22Name: string | null;
  customAttribute22Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute22DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute22DisplayFlag: boolean;
  customAttribute23Name: string | null;
  customAttribute23Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute23DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute23DisplayFlag: boolean;
  customAttribute24Name: string | null;
  customAttribute24Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute24DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute24DisplayFlag: boolean;
  customAttribute25Name: string | null;
  customAttribute25Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute25DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute25DisplayFlag: boolean;
  customAttribute26Name: string | null;
  customAttribute26Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute26DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute26DisplayFlag: boolean;
  customAttribute27Name: string | null;
  customAttribute27Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute27DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute27DisplayFlag: boolean;
  customAttribute28Name: string | null;
  customAttribute28Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute28DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute28DisplayFlag: boolean;
  customAttribute29Name: string | null;
  customAttribute29Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute29DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute29DisplayFlag: boolean;
  customAttribute30Name: string | null;
  customAttribute30Style: valueof<keyof typeof ATTRIBUTE_STYLE> | null;
  customAttribute30DisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null;
  customAttribute30DisplayFlag: boolean;
}

export interface CreateProjectTaskAttributeValueOption {
  projectId: number,
  attributeCd: valueof<keyof typeof AttributeCd>,
  value: string | null,
  colorCd: valueof<keyof typeof ColorCd>,
  attributeItemContent: string | null,
}

export interface CreateTaskAttributeValueOptionResponse {
  results: TaskAttributeValueOption;
}

/**
 * プロジェクト一覧取得API
 */
export interface LoadFindProjects {
  readonly organizationId: number;
  readonly projectName: string;
  readonly projectIconImage: string | null;
  readonly projectStartDate: Date | null;
  readonly projectWillFinishDate: Date | null;
  readonly projectFinishDate: Date | null;
  readonly openFlag: boolean;
  readonly projectId?: number;
}

export interface FindProjectsResponse {
  readonly results: LoadFindProjects[];
}

export interface DeleteProjectQueryDto {
  'organization-id': number;
}